import UpdateSubscriptionPaymentPage from './UpdateSubscriptionPaymentPage'

export default UpdateSubscriptionPaymentPage
